import React from 'react';
import parse from 'html-react-parser';
import mednalogo from "../Images/bg/mednalogo.png"

export default function TextWidget({ logoUrl, text, logoWidth }) {
  console.log("logoWidth",logoWidth)
  return (
    <div className="cs_text_widget">
      {logoUrl && <img src={logoUrl} alt="Logo" width={logoWidth ? logoWidth : '100%'} />}
      {/* {text && <p className="cs_medium">{parse(text)}</p>} */}
    </div>
  );
}
